import React from 'react';
import { Style } from 'react-style-tag';

const CustomColors = ({ customColors, customCss, customJs }) => (
  <React.Fragment>
    {Object.keys(customColors).map(colorClass =>
      (<Style key={colorClass}>{`.${colorClass} .tc {background: ${customColors[colorClass]}}`}</Style>))}
    {!!customCss && (<Style>{customCss}</Style>)}
    {!!customJs && (<script id="customJs" type="text/javascript">{customJs}</script>)}
  </React.Fragment>
);

export default CustomColors;



// WEBPACK FOOTER //
// ./src/components/customColors/CustomColors.jsx